export default __webpack_public_path__ + "static/media/pictogramBeaconBusinessVehicle64.1498b46a.svg";